import { Store } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { nombrePais } from './formato'

/** Pestaña «Empresas»: las instancias (tenants) aprovisionadas para este cliente. */
export default function Empresas({ ficha }) {
  const inst = ficha.instancias || []
  if (inst.length === 0) return <Card className="p-6 text-center text-neutral-500 dark:text-neutral-400">Sin instancias aprovisionadas.</Card>
  return (
    <div className="space-y-3">
      {inst.map((i, idx) => (
        <Card key={i.tenantId || idx} className="p-4 flex items-center gap-3">
          <Store size={18} className="text-neutral-400 dark:text-neutral-500 shrink-0" />
          <div className="min-w-0">
            <p className="font-medium text-neutral-900 dark:text-neutral-50 truncate">{i.empresaNombre || ficha.empresaNombre}</p>
            <p className="text-caption text-neutral-500 dark:text-neutral-400 truncate">{i.tenantId} · {i.giro || ficha.giro} · {nombrePais(i.pais || ficha.pais)} · {i.host || '—'}</p>
          </div>
        </Card>
      ))}
    </div>
  )
}
